import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { CreateCampaignEntity } from '../../domain/entities/CreateCampaignEntity'
import { CampaignStepModel } from './CampaignStepModel'
import type { CampaignTranslationModel } from './CampaignTranslationModel'
import { CampaignRegionsModel } from './CampaignRegionsModel'

export class CreateCampaignModel extends CreateCampaignEntity {
  declare startDate: string
  declare endDate: string
  userIds?: Array<string> | null
  includeBranchIds?: Array<number> | null
  excludeBranchIds?: Array<number> | null
  groupIds?: Array<number> | null
  channelIds?: Array<number> | null
  serviceIds?: Array<number> | null
  declare steps?: Array<CampaignStepModel> | null
  declare translations?: Array<CampaignTranslationModel> | null
  constructor(dataDto: CreateCampaignEntity) {
    super()
    const stepsModels = dataDto.steps?.map((step) => new CampaignStepModel(step))
    const campaignRegionsModels = dataDto.regions?.map((region) => new CampaignRegionsModel(region))

    mapEntityProperties<CreateCampaignModel>(this, dataDto, {
      exclude: ['users', 'includeBranches', 'excludeBranches', 'groups', 'channels', 'services'],
      map: {
        steps: stepsModels,
        userIds: dataDto.users?.map((user) => user.id),
        includeBranchIds: dataDto.includeBranches?.map((branch) => branch.id),
        excludeBranchIds: dataDto.excludeBranches?.map((branch) => branch.id),
        groupIds: dataDto.groups?.map((group) => group.id),
        channelIds: dataDto.channels?.map((channel) => channel.id),
        serviceIds: dataDto.services?.map((service) => service.id),
        regions: campaignRegionsModels
      }
    })
  }
}
